import { extractUniqueShops } from "./sub/extractUniqueShops";

export const createOrderForm = (orders) => {
  // フィールド欠落データが混ざっていても例外にならないよう null 安全に比較する
  const sortedOrders = orders.sort((a, b) => {
    // shop_idで昇順にソート
    const shopIdComparison = String(a.shop_id || "").localeCompare(
      String(b.shop_id || "")
    );
    if (shopIdComparison !== 0) return shopIdComparison;

    // delivery_office_idで昇順にソート
    const deliveryOfficeIdComparison =
      (Number(a.delivery_office_id) || 0) - (Number(b.delivery_office_id) || 0);
    if (deliveryOfficeIdComparison !== 0) return deliveryOfficeIdComparison;

    // order_user_idで昇順にソート
    const orderUserIdComparison =
      (Number(a.order_user_id) || 0) - (Number(b.order_user_id) || 0);
    if (orderUserIdComparison !== 0) return orderUserIdComparison;

    // order_numberで昇順にソート
    return (Number(a.order_number) || 0) - (Number(b.order_number) || 0);
  });
  //   const uniqueShops = extractUniqueShops(sortedOrders);
  const { orderForms: forms, uniqueShops: shops } =
    generateOrderForms(sortedOrders);
  return { forms, shops };
};
export const generateOrderForms = (orders) => {
  const uniqueShops = [];
  const shopIdSet = new Set();

  // 配列から uniqueShops を作成
  orders.forEach((order) => {
    if (!shopIdSet.has(order.shop_id)) {
      uniqueShops.push({
        shop_id: order.shop_id,
        shop_name: order.shop_name,
        shop_fax: order.shop_fax,
        shop_to: order.shop_to,
        shop_cc: order.shop_cc,
      });
      shopIdSet.add(order.shop_id);
    }
  });

  const orderForms = [];

  // 各 shop_id ごとに注文書を作成
  uniqueShops.forEach((shop) => {
    const shopOrders = orders.filter((order) => order.shop_id === shop.shop_id);

    let currentOrderList = [];
    let currentOrderUser = null;
    let currentDeliveryOffice = null;
    let currentPage = [];
    let currentPageTotalPrice = 0;
    let pageCounter = 0;

    shopOrders.forEach((order, index) => {
      const isNewPageNeeded =
        currentPage.length >= 6 || // 6件を超える場合
        (currentOrderUser && currentOrderUser !== order.order_user_id) || // order_user_idが異なる場合
        (currentDeliveryOffice &&
          currentDeliveryOffice !== order.delivery_office_id); // delivery_office_idが異なる場合

      if (isNewPageNeeded) {
        // ページをリセットして、次のページに進む
        orderForms.push({
          shop_id: shop.shop_id,
          shop_name: shop.shop_name,
          shop_fax: shop.shop_fax,
          shop_to: shop.shop_to,
          shop_cc: shop.shop_cc,
          orders: currentPage,
          totalPrice: currentPageTotalPrice,
          pageNumber: ++pageCounter,
        });

        // 初期化
        currentPage = [];
        currentPageTotalPrice = 0;
      }

      // 注文をページに追加
      currentPage.push(order);
      currentPageTotalPrice += order.totalPrice;

      // 次の注文の判定用に order_user_id と delivery_office_id を保持
      currentOrderUser = order.order_user_id;
      currentDeliveryOffice = order.delivery_office_id;
    });

    // 最後のページを追加
    if (currentPage.length > 0) {
      orderForms.push({
        shop_id: shop.shop_id,
        shop_name: shop.shop_name,
        shop_fax: shop.shop_fax,
        shop_to: shop.shop_to,
        shop_cc: shop.shop_cc,
        orders: currentPage,
        totalPrice: currentPageTotalPrice,
        pageNumber: ++pageCounter,
      });
    }
  });

  return { orderForms, uniqueShops };
};

/*
reactPDFで注文書を作るための配列を用意したい。
shop_idが異なる場合はPDFは分けたい。
またuniqueShopsが同じものは同じPDFにまとめるが、以下の条件で改ページする。
1ページ当たりの注文数が12を超える場合
order_user_idが異なる場合
delivery_office_idが異なる場合

注文書を作成するのに必要な情報は以下の通り。

order_user_id: orderInfo.order_user_id,
        order_user_name: orderInfo.order_user_name,
        order_user_dep_id: orderInfo.order_user_dep_id,
        order_user_dep_name: orderInfo.order_user_dep_name,
        order_user_email: orderInfo.order_user_email,
        order_base_id: orderInfo.order_base_id,
        order_base_name: orderInfo.order_base_name,
        order_department_id: orderInfo.order_department_id,
        order_department_name: orderInfo.order_department_name,

        billing_user_flg: orderInfo.billing_user_flg,
        billing_user_id: orderInfo.billing_user_id,
        billing_user_name: orderInfo.billing_user_name,
        billing_user_dep_id: orderInfo.billing_user_dep_id,
        billing_user_dep_name: orderInfo.billing_user_dep_name,

        billing_company_flg: orderInfo.billing_company_flg,
        billing_company_id: orderInfo.billing_company_id,
        billing_company_name_full: orderInfo.billing_company_name_full,
        billing_company_name: orderInfo.billing_company_name,

        remark_on_order: orderInfo.remark_on_order,

        delivery_office_id: orderInfo.delivery_office_id,
        delivery_office_name: orderInfo.delivery_office_name,
        delivery_office_address_main: orderInfo.delivery_office_address_main,
        delivery_office_address_sub: orderInfo.delivery_office_address_sub,
        delivery_office_tell: orderInfo.delivery_office_tell,

        delivery_department: orderInfo.delivery_department,
         product_id: product.productId, // 元の商品ID
        category_id: product.category,
        category_name: product.category_name,
        description: product.description,
        idin: product.idin,
        idout: product.idout,
        images: product.images,
        name: product.name,
        price: product.price,
        quantity: product.quantity,
        totalPrice: product.totalPrice,
        size: product.size,
        maker_id: product.maker,
        maker_name: product.maker_name,
        shop_id: product.shop,
        shop_name: product.shop_name,
        shop_fax: product.shop_fax,
        shop_to: product.shop_to,
        shop_cc: product.shop_cc,
        embroidery: product.embroidery,
        remarks: product.remarks,
        added_at: product.added_at,
        deduction_id: product.deduction_id,
        deduction_name: product.deduction_name,

        上記に合わせて各ページごとのtotalPriceの合計も管理したい。注文書に印刷するためである。
        適切な配列を生成してほしい。
        可能であればReactPDFへの適用方法も教えてほしい。フォーマットはこちらで用意する。
        */
